/**
 * utils/api.js - the small fetch wrapper the feature API modules share
 * (costs/costApi.js, financeInvoices/financeInvoicesApi.js,
 * spareParts/sparePartsApi.js, quotes/quoteApi.js). A call answers
 * { ok, status, body } and never throws; body.error says what went wrong.
 * (src/index.js adds the sign-in token to every fetch.)
 */

/** fetch + JSON: { ok, status, body }; a network failure is status 0. */
export const json = async (url, init) => {
  try {
    const r = await fetch(url, init);
    const body = await r.json().catch(() => null);
    return { ok: r.ok, status: r.status, body };
  } catch {
    return { ok: false, status: 0, body: { error: 'Could not reach the server.' } };
  }
};

/** A JSON request body for `method` (an absent body sends {}). */
export const send = (method, body) => ({ method, headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body || {}) });

/** '?a=1&b=x' from the set values (true -> '1'; blank, null and false left out), or ''. */
export const qs = (params) => {
  const usp = new URLSearchParams();
  Object.entries(params || {}).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== '' && v !== false) usp.set(k, v === true ? '1' : String(v));
  });
  const s = usp.toString();
  return s ? `?${s}` : '';
};

/** The error a failed call should show. */
export const errorOf = (res, fallback) => (res && res.body && res.body.error) || fallback;
